var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _vm.isMobile === false
      ? _c(
          "div",
          { staticClass: "job-search-buttons" },
          [
            _c(
              "b-row",
              { staticClass: "row no-gutters mt-2" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "btn btn-outline rounded",
                    on: {
                      click: function ($event) {
                        return _vm.changeFilterIsActive()
                      },
                    },
                  },
                  [
                    _c("b-icon", {
                      staticClass: "mr-3",
                      attrs: { icon: "sliders", scale: "1.2", variant: "dark" },
                    }),
                    _vm._v(_vm._s(_vm.t.jobSearch_V2_Settings)),
                  ],
                  1
                ),
                _vm.canSaveSearch
                  ? _c(
                      "b-button",
                      {
                        staticClass: "btn rounded btn-outline",
                        on: {
                          click: function ($event) {
                            return _vm.clearSearch()
                          },
                        },
                      },
                      [
                        _c("b-icon", {
                          staticClass: "mr-2",
                          attrs: { icon: "x", scale: "1.2" },
                        }),
                        _c("span", [
                          _vm._v(_vm._s(_vm.t.jobSearch_V2_Clear_Search)),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.canSaveSearch
                  ? _c(
                      "b-button",
                      {
                        staticClass: "btn btn-outline rounded",
                        on: {
                          click: function ($event) {
                            return _vm.openSaveSearchModal()
                          },
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.t.jobSearch_V2_Save_Search)),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _c(
                  "b-button",
                  {
                    staticClass: "btn btn-brand-light rounded",
                    on: {
                      click: function ($event) {
                        return _vm.startSearch()
                      },
                    },
                  },
                  [
                    _c("b-icon", {
                      staticClass: "mr-2",
                      attrs: { icon: "search" },
                    }),
                    _c("span", [_vm._v(_vm._s(_vm.t.jobSearch_V2_Search))]),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _vm.isMobile && _vm.mobileFiltersIsOpen === false
      ? _c(
          "div",
          {
            staticClass:
              "bottom-button fixed-bottom d-flex justify-content-end w-100",
          },
          [
            _vm.selectedJobPosting === undefined
              ? [
                  _vm.canSaveSearch === true
                    ? _c(
                        "b-button",
                        {
                          staticClass: "btn rounded m-2",
                          attrs: { variant: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.openSaveSearchModal()
                            },
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.t.jobSearch_V2_Save_Search)),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "b-button",
                    {
                      staticClass: "btn rounded m-2",
                      attrs: { variant: "light" },
                      on: {
                        click: function ($event) {
                          return _vm.startSearch()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.t.jobSearch_V2_Search))]
                  ),
                ]
              : [
                  _vm.selectedJobPosting !== undefined
                    ? _c(
                        "b-button",
                        {
                          staticClass: "btn rounded m-2",
                          attrs: { variant: "light" },
                          on: {
                            click: function ($event) {
                              return _vm.goToPage(_vm.selectedJobPosting.Url)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.t.jobSearch_V2_Go_To_Job))]
                      )
                    : _vm._e(),
                ],
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }